import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-8 col-lg-7" }
const _hoisted_3 = { class: "col-xxl-4 col-lg-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Ticket = _resolveComponent("Ticket")!
  const _component_TicketDescription = _resolveComponent("TicketDescription")!
  const _component_Comments = _resolveComponent("Comments")!
  const _component_Attachments = _resolveComponent("Attachments")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Ticket),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_TicketDescription),
        _createVNode(_component_Comments)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Attachments)
      ])
    ])
  ]))
}